// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3f9b3f85","72":"078f6b99","77":"46e35886","164":"6b3dfa75","315":"48580a84","489":"fdd1454d","544":"ee241467","667":"9fe81219","707":"b1c8d4b0","822":"c20fb2a3","905":"bc8b0fff","949":"3a0d6ba9","970":"f5f3ea96"}[chunkId] + ".chunk.js";
};